export function transformResponseMessageToErrorMessage(responseMessage: string): string {
    let errorMessageKey = "secure-exports.generate.error.generic"; // Default message

    switch (responseMessage) {
        case "You can only export once per 60 seconds.":
            errorMessageKey = "secure-exports.generate.error.60sec";
            break;
        case "The maximum date range is 1 year.":
            errorMessageKey = "secure-exports.generate.error.1year";
            break;
        case "Could not generate or upload CSV export. Error: Could upload to S3: The specified bucket does not exist.":
            errorMessageKey = "secure-exports.generate.error.bucket";
            break;
        case "No data found to export.":
            errorMessageKey = "secure-exports.generate.error.no-data";
            break;
    }
    return errorMessageKey;
}
